import { useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { getMode, toggleMode } from '../lib/theme';
import { t } from '../lib/i18n';

// Light/dark switch. Flipping toggleMode() rewrites data-lms-mode on <html>, so
// every var(--lms-*) surface repaints via CSS; this button only re-renders its
// own icon.
export default function ModeToggle({ onBand = false }) {
  const [mode, setMode] = useState(getMode());
  return (
    <button
      onClick={() => setMode(toggleMode())}
      title={mode === 'dark' ? t('Light mode') : t('Dark mode')}
      aria-label={t('Toggle dark mode')}
      className={onBand
        ? 'flex h-11 w-11 items-center justify-center rounded-lg border border-lms-band-text text-lms-band-text hover:bg-white/10'
        : 'flex h-[34px] w-[34px] items-center justify-center rounded-md border border-lms-border text-lms-muted hover:border-[var(--lms-hover-border)] hover:text-lms-text'}
    >
      {mode === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
